import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { QueryBarWebsiteItem } from "@similarweb/ui-components";

export const VS = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[300])};
    margin: 0 8px;
`;

export const ButtonWrapper = styled.div`
    margin-left: 8px;
`;

export const QueryBarWebsiteItemStyled = styled(QueryBarWebsiteItem)<{ $isLast?: boolean }>`
    background-color: ${colorsPalettes.carbon[50]};
    max-width: 198px;
    @media (max-width: 1280px) {
        max-width: 180px;
    }
    ${({ $isLast }) => $isLast && `margin-left: 16px;`}
`;
